import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  addObj,
  modifyObj,
  deleteObj,
  clientSearchByName,
  clientGetMyTransportVehicleInfoGroupOverview,
  getRootTransportVehicleInfoGroups,
  getChildrenGroups,
  getDirectlyUnderBindAll,
  getDirectlyUnderBindPage,
  getClientBindTransportVehicleInfoGroupsPage,
  bindTransportVehicleInfoGroupsToUser,
  unBindUserTransportVehicleInfoGroups,
} from '@/api/transportvehicleinfogroupserv'

export default {
  state: {
    state_TransportVehicleInfoGroup_GetAllResult: null,
    state_TransportVehicleInfoGroup_SearchByNameResult: null,
    state_TransportVehicleInfoGroup_GetPageResult: null,
    state_TransportVehicleInfoGroup_GetDetailResult: null,
    state_TransportVehicleInfoGroup_AddObjResult: null,
    state_TransportVehicleInfoGroup_ModifyObjResult: null,
    state_TransportVehicleInfoGroup_DeleteObjResult: null,
    state_TransportVehicleInfoGroup_ClientSearchByNameResult: null,
    state_TransportVehicleInfoGroup_ClientGetMyTransportVehicleInfoGroupOverviewResult: null,
    state_TransportVehicleInfoGroup_GetRootTransportVehicleInfoGroupsResult: null,
    state_TransportVehicleInfoGroup_GetChildrenGroupsResult: null,
    state_TransportVehicleInfoGroup_GetDirectlyUnderBindAllResult: null,
    state_TransportVehicleInfoGroup_GetDirectlyUnderBindPageResult: null,
    state_TransportVehicleInfoGroup_GetClientBindTransportVehicleInfoGroupsPageResult: null,
    state_TransportVehicleInfoGroup_BindTransportVehicleInfoGroupsToUserResult: null,
    state_TransportVehicleInfoGroup_UnBindUserTransportVehicleInfoGroupsResult: null,
  },
  mutations: {
    SET_TRANSPORTVEHICLEINFOGROUP_GETALL_RESULT: (state, rst) => {
      state.state_TransportVehicleInfoGroup_GetAllResult = rst;
    },
    SET_TRANSPORTVEHICLEINFOGROUP_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_TransportVehicleInfoGroup_SearchByNameResult = rst;
    },
    SET_TRANSPORTVEHICLEINFOGROUP_GETPAGE_RESULT: (state, rst) => {
      state.state_TransportVehicleInfoGroup_GetPageResult = rst;
    },
    SET_TRANSPORTVEHICLEINFOGROUP_GETDETAIL_RESULT: (state, rst) => {
      state.state_TransportVehicleInfoGroup_GetDetailResult = rst;
    },
    SET_TRANSPORTVEHICLEINFOGROUP_ADDOBJ_RESULT: (state, rst) => {
      state.state_TransportVehicleInfoGroup_AddObjResult = rst;
    },
    SET_TRANSPORTVEHICLEINFOGROUP_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_TransportVehicleInfoGroup_ModifyObjResult = rst;
    },
    SET_TRANSPORTVEHICLEINFOGROUP_DELETEOBJ_RESULT: (state, rst) => {
      state.state_TransportVehicleInfoGroup_DeleteObjResult = rst;
    },
    SET_TRANSPORTVEHICLEINFOGROUP_CLIENTSEARCHBYNAME_RESULT: (state, rst) => {
      state.state_TransportVehicleInfoGroup_ClientSearchByNameResult = rst;
    },
    SET_TRANSPORTVEHICLEINFOGROUP_CLIENTGETMYTRANSPORTVEHICLEINFOGROUPOVERVIEW_RESULT: (state, rst) => {
      state.state_TransportVehicleInfoGroup_ClientGetMyTransportVehicleInfoGroupOverviewResult = rst;
    },
    SET_TRANSPORTVEHICLEINFOGROUP_GETROOTTRANSPORTVEHICLEINFOGROUPS_RESULT: (state, rst) => {
      state.state_TransportVehicleInfoGroup_GetRootTransportVehicleInfoGroupsResult = rst;
    },
    SET_TRANSPORTVEHICLEINFOGROUP_GETCHILDRENGROUPS_RESULT: (state, rst) => {
      state.state_TransportVehicleInfoGroup_GetChildrenGroupsResult = rst;
    },
    SET_TRANSPORTVEHICLEINFOGROUP_GETDIRECTLYUNDERBINDALL_RESULT: (state, rst) => {
      state.state_TransportVehicleInfoGroup_GetDirectlyUnderBindAllResult = rst;
    },
    SET_TRANSPORTVEHICLEINFOGROUP_GETDIRECTLYUNDERBINDPAGE_RESULT: (state, rst) => {
      state.state_TransportVehicleInfoGroup_GetDirectlyUnderBindPageResult = rst;
    },
    SET_TRANSPORTVEHICLEINFOGROUP_GETCLIENTBINDTRANSPORTVEHICLEINFOGROUPSPAGE_RESULT: (state, rst) => {
      state.state_TransportVehicleInfoGroup_GetClientBindTransportVehicleInfoGroupsPageResult = rst;
    },
    SET_TRANSPORTVEHICLEINFOGROUP_BINDTRANSPORTVEHICLEINFOGROUPSTOUSER_RESULT: (state, rst) => {
      state.state_TransportVehicleInfoGroup_BindTransportVehicleInfoGroupsToUserResult = rst;
    },
    SET_TRANSPORTVEHICLEINFOGROUP_UNBINDUSERTRANSPORTVEHICLEINFOGROUPS_RESULT: (state, rst) => {
      state.state_TransportVehicleInfoGroup_UnBindUserTransportVehicleInfoGroupsResult = rst;
    },
  },
  actions: {
    TransportVehicleInfoGroupServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoGroupServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoGroupServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoGroupServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoGroupServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoGroupServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoGroupServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoGroupServ_ClientSearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        clientSearchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_CLIENTSEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_CLIENTSEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoGroupServ_ClientGetMyTransportVehicleInfoGroupOverview({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        clientGetMyTransportVehicleInfoGroupOverview(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_CLIENTGETMYTRANSPORTVEHICLEINFOGROUPOVERVIEW_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_CLIENTGETMYTRANSPORTVEHICLEINFOGROUPOVERVIEW_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoGroupServ_GetRootTransportVehicleInfoGroups({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getRootTransportVehicleInfoGroups(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_GETROOTTRANSPORTVEHICLEINFOGROUPS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_GETROOTTRANSPORTVEHICLEINFOGROUPS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoGroupServ_GetChildrenGroups({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getChildrenGroups(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_GETCHILDRENGROUPS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_GETCHILDRENGROUPS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoGroupServ_GetDirectlyUnderBindAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDirectlyUnderBindAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_GETDIRECTLYUNDERBINDALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_GETDIRECTLYUNDERBINDALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoGroupServ_GetDirectlyUnderBindPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDirectlyUnderBindPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_GETDIRECTLYUNDERBINDPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_GETDIRECTLYUNDERBINDPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoGroupServ_GetClientBindTransportVehicleInfoGroupsPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientBindTransportVehicleInfoGroupsPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_GETCLIENTBINDTRANSPORTVEHICLEINFOGROUPSPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_GETCLIENTBINDTRANSPORTVEHICLEINFOGROUPSPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoGroupServ_BindTransportVehicleInfoGroupsToUser({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        bindTransportVehicleInfoGroupsToUser(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_BINDTRANSPORTVEHICLEINFOGROUPSTOUSER_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_BINDTRANSPORTVEHICLEINFOGROUPSTOUSER_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoGroupServ_UnBindUserTransportVehicleInfoGroups({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        unBindUserTransportVehicleInfoGroups(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_UNBINDUSERTRANSPORTVEHICLEINFOGROUPS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFOGROUP_UNBINDUSERTRANSPORTVEHICLEINFOGROUPS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_TransportVehicleInfoGroup_GetAllResult: state => {
      return state.state_TransportVehicleInfoGroup_GetAllResult;
    },
    get_TransportVehicleInfoGroup_SearchByNameResult: state => {
      return state.state_TransportVehicleInfoGroup_SearchByNameResult;
    },
    get_TransportVehicleInfoGroup_GetPageResult: state => {
      return state.state_TransportVehicleInfoGroup_GetPageResult;
    },
    get_TransportVehicleInfoGroup_GetDetailResult: state => {
      return state.state_TransportVehicleInfoGroup_GetDetailResult;
    },
    get_TransportVehicleInfoGroup_AddObjResult: state => {
      return state.state_TransportVehicleInfoGroup_AddObjResult;
    },
    get_TransportVehicleInfoGroup_ModifyObjResult: state => {
      return state.state_TransportVehicleInfoGroup_ModifyObjResult;
    },
    get_TransportVehicleInfoGroup_DeleteObjResult: state => {
      return state.state_TransportVehicleInfoGroup_DeleteObjResult;
    },
    get_TransportVehicleInfoGroup_ClientSearchByNameResult: state => {
      return state.state_TransportVehicleInfoGroup_ClientSearchByNameResult;
    },
    get_TransportVehicleInfoGroup_ClientGetMyTransportVehicleInfoGroupOverviewResult: state => {
      return state.state_TransportVehicleInfoGroup_ClientGetMyTransportVehicleInfoGroupOverviewResult;
    },
    get_TransportVehicleInfoGroup_GetRootTransportVehicleInfoGroupsResult: state => {
      return state.state_TransportVehicleInfoGroup_GetRootTransportVehicleInfoGroupsResult;
    },
    get_TransportVehicleInfoGroup_GetChildrenGroupsResult: state => {
      return state.state_TransportVehicleInfoGroup_GetChildrenGroupsResult;
    },
    get_TransportVehicleInfoGroup_GetDirectlyUnderBindAllResult: state => {
      return state.state_TransportVehicleInfoGroup_GetDirectlyUnderBindAllResult;
    },
    get_TransportVehicleInfoGroup_GetDirectlyUnderBindPageResult: state => {
      return state.state_TransportVehicleInfoGroup_GetDirectlyUnderBindPageResult;
    },
    get_TransportVehicleInfoGroup_GetClientBindTransportVehicleInfoGroupsPageResult: state => {
      return state.state_TransportVehicleInfoGroup_GetClientBindTransportVehicleInfoGroupsPageResult;
    },
    get_TransportVehicleInfoGroup_BindTransportVehicleInfoGroupsToUserResult: state => {
      return state.state_TransportVehicleInfoGroup_BindTransportVehicleInfoGroupsToUserResult;
    },
    get_TransportVehicleInfoGroup_UnBindUserTransportVehicleInfoGroupsResult: state => {
      return state.state_TransportVehicleInfoGroup_UnBindUserTransportVehicleInfoGroupsResult;
    },
  }
}